import { ApolloCache } from '@apollo/client'
import { GetProjectSharesQuery, GetSharesQuery } from '@sketch/gql-types'
import { removeFromPaginated } from '@sketch/modules-common'

export interface HandleShareRestoredProps {
  cache: ApolloCache<any>
  identifier: string
  workspaceIdentifier: string
  projectIdentifier?: string
}

export const handleShareRestored = (props: HandleShareRestoredProps) => {
  const { cache, identifier, workspaceIdentifier, projectIdentifier } = props

  // ProjectFragment should be removed once BE returns the newer types in the getTrash
  // https://github.com/sketch-hq/Cloud/issues/11226
  removeFromPaginated(
    cache,
    { __typename: 'Share', identifier },
    key => key.includes('.workspaceTrash') || key.includes('.shares')
  )

  // there still can be smaller fragments in the cache
  // let's remove all of them.
  removeFromPaginated(
    cache,
    { __typename: 'TrashedShare', identifier },
    key => key.includes('.workspaceTrash') || key.includes('.shares')
  )

  // Remove from cache every query related with this workspace shares list
  // We are never fully aware of the restored share placement and trying to match that would take a lot of cache operations
  // This way the view will be refetched from scratch if needed to make sure
  // we always get the correct server information
  const workspaceCacheId = cache.identify({
    __typename: 'Workspace',
    identifier: workspaceIdentifier,
  })
  type WorkspaceField = keyof GetSharesQuery['workspace']
  const fieldNameInWorkspace: WorkspaceField = 'shares'

  cache.evict({
    id: workspaceCacheId,
    fieldName: fieldNameInWorkspace,
  })

  const projectCacheId = cache.identify({
    __typename: 'Project',
    identifier: projectIdentifier,
  })
  type ProjectField = keyof GetProjectSharesQuery['project']
  const fieldNameInProject: ProjectField = 'shares'

  cache.evict({
    id: projectCacheId,
    fieldName: fieldNameInProject,
  })

  cache.gc()
}
